export default "__VITE_ASSET__e4c977ed__"